import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';

interface AssistantMessage {
  id: string;
  message: string;
}

interface AssistantProps {
  userLocation: { lat: number; lng: number } | null;
  places: any[];
  isSearching: boolean;
}

export default function Assistant({ userLocation, places, isSearching }: AssistantProps) {
  const [message, setMessage] = useState<AssistantMessage | null>(null);

  useEffect(() => {
    if (userLocation && isSearching) {
      // Mesajı göster
      setTimeout(() => {
        if (places.length > 0) {
          const nearest = places[0];
          setMessage({
            id: '1',
            message: `${places.length} taksi durağı bulundu. En yakın durak ${nearest.distance} mesafede.`
          });
        } else {
          setMessage({
            id: '1',
            message: 'Yakınınızda taksi durağı bulunamadı.'
          });
        }

        // 4 saniye sonra kaybolma animasyonu başlat
        setTimeout(() => {
          const element = document.querySelector('.notification-message');
          if (element) {
            element.classList.add('fade-out');
          }
          
          // Animasyon bittikten sonra mesajı kaldır
          setTimeout(() => {
            setMessage(null);
          }, 500);
        }, 6000);
      }, 1000);
    }
  }, [userLocation, places, isSearching]);

  if (!message) return null;

  return (
    <div className="fixed top-4 right-4 left-4 md:left-auto z-50 md:w-96 notification-message animate-fade-in-up">
      <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 px-4 py-3 rounded-2xl shadow-lg shadow-yellow-400/20">
        {/* Dismiss Button */}
        <button
          onClick={() => setMessage(null)}
          className="absolute -top-2 -right-2 p-1 bg-gray-900 text-yellow-400 rounded-full hover:bg-gray-800 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Content */}
        <div className="flex items-start gap-3">
          <div className="p-2 bg-gray-900/10 rounded-xl">
            <Bell className="w-5 h-5 animate-bounce-subtle" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium line-clamp-2">
              {message.message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}